// @flow
import React from 'react'
import numeral from 'numeral'

numeral.options.scalePercentBy100 = false

type Props = {
  label: string,
  value: string,
  format: string
}

export default class StatsBadge extends React.Component<Props> {
  render () {
    return (
      <div style={{
        display: 'inline-block',
        width: '100px',
        height: '50px',
        margin: '10px',
        color: 'black',
        verticalAlign: 'top',
        fontFamily: 'Lato',
        textAlign: 'center'
      }}>
        <span style={{
          fontSize: '34px'
        }}>
          {
            this.props.value === null
              ? '-'
              : numeral(this.props.value).format(this.props.format)
          }
        </span>
        <br />
        <span style={{
          textAlign: 'center',
          position: 'relative',
          color: 'gray',
          fontSize: '10px',
          top: '-4px'
        }}>{this.props.label}</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/Header/StatsBadge.js